/* eslint camelcase: 0 */

import { Scheduler as Data } from '@/typings/api/Scheduler'
import { Model, createMessages } from '@/helpers/Model'


export class TimesheetModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить Расписание',
    edit: 'Редактировать Расписание',
    view: (data: TimesheetModel) => 'Расписание «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Расписание',
  });

  public static readonly modal_delete = createMessages({
    delete: (data: TimesheetModel) => 'Удаление расписания «{name}»'
      .replace('{name}', data.name || '...'),
    delete_all: 'Удаление выбранных расписаний',
    delete_all_partly: 'Удаление части выбранных расписаний',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });
}
